import React, { useEffect, useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ContainerComponent from './ContainerComponent';
import { SET_VALUE } from '../formReducer';

interface Props {
  value: any;
  formId: string;
  formName: string;
  formDispatch: any;
  item: {
    label: string;
    name: string;
    placeholder?: string;
    subtype?: string;
    required?: boolean;
    values: { label: string; selected: boolean; value: string }[];
    description?: string;
  };
  readOnly: boolean;
}

const decodeHtmlEntities = (str: string) => {
  if (!str) return str;
  const txt = typeof window !== 'undefined' ? document.createElement('textarea') : null;
  if (!txt) return str;
  txt.innerHTML = str;
  return txt.value;
};

const CheckboxFieldComponent: React.FC<Props> = ({
  value,
  formDispatch,
  formId,
  formName,
  item: { label, values, name: fieldId, required, description },
  readOnly,
}) => {
  const convertValues = (
    values: { label: string; selected: boolean; value: string }[]
  ) => {
    const out: { [key: string]: boolean } = {};
    (values || []).forEach((item) => {
      out[item.value] = item.selected;
    });
    return out;
  };

  const [convertedValues, setConvertedValues] = useState<any>(value ? value : convertValues(values || []));

  useEffect(() => {
    formDispatch({ type: SET_VALUE, payload: { value: convertedValues, fieldId, formId } });
    formDispatch({ type: SET_VALUE, payload: { value: convertedValues, fieldId, formId: formName } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convertedValues]);

  const handleChange = ({ target: { name, checked } }: any) => {
    const newConvertedValues: any = { ...convertedValues };
    newConvertedValues[name] = checked;
    setConvertedValues(newConvertedValues);
  };

  return (
    <ContainerComponent label={label} required={!!required} description={description}>
      <FormControl component="fieldset">
        <FormGroup>
          {(values || []).map(({ label, value: value_ }) => (
            <FormControlLabel
              key={label}
              control={
                <Checkbox
                  checked={!!(convertedValues && convertedValues[value_])}
                  onChange={handleChange}
                  name={value_}
                  color="primary"
                />
              }
              label={decodeHtmlEntities(label)}
              style={{ fontSize: 14 }}
              disabled={readOnly}
            />
          ))}
        </FormGroup>
      </FormControl>
    </ContainerComponent>
  );
};

export default CheckboxFieldComponent;
